export type StepInfo = {
  id: number
  name: string
  isCompleted: boolean
  completedAt: Date
  dueDate: Date
  description?: string
  criterion?: string
}

export type GoalInfo = {
  id: number
  name: string
  isCompleted: boolean
  completedAt: Date
  dueDate: Date
  description?: string
  criterion?: string
  steps?: StepInfo[]
}

export type IndividualPlanInfo = {
  id: number
  name: string
  isClosed: boolean
  closedAt: Date
  dueDate: Date
  description?: string
  contractedGoal?: string
  goals?: GoalInfo[]
}
export type ProgramEnrollmentCommonInfo = {
  id: number
  programId: number
  programName: string
  isTerminated: boolean
  isArchived: boolean
  archivedAt: Date
  dueDate?: Date
  contractedGoal?: string
}

export type SubprogramEnrollmentInfo = {
  individualPlans?: IndividualPlanInfo[]
} & ProgramEnrollmentCommonInfo

export type ProgramEnrollmentInfo = {
  subprogramEnrollments?: SubprogramEnrollmentInfo[]
} & ProgramEnrollmentCommonInfo

export class ClientIPList {
  static serviceName = 'features/client-ip/list'
  programEnrollment: ProgramEnrollmentInfo[] = []
}
